// Состояние аккордеона мобильных карточек (D11): «Библиотека» и «Итог» на
// телефоне сворачиваются в шапку-кнопку и разворачиваются обратно. Держим
// это в sessionStorage, а не в src/store/storage.ts (тот — под localStorage
// и постоянное состояние поездки/языка/аккаунта): сворачивание — сиюминутная
// разметка текущего экрана, а не настройка профиля. При следующем визите
// лучше пересчитать дефолт заново от актуального state.variants.length, чем
// тащить решение из прошлой сессии на телефоне другого размера.
//
// Подход к самому хранилищу — тот же, что в storage.ts: feature-detect перед
// использованием и try/catch вокруг каждого обращения, чтобы приватный режим
// или переполненная квота не роняли панель, а просто не запоминали выбор.

const KEY_PREFIX = 'plan-flights.mobileAccordion.';
const PROBE_KEY = '__plan_flights_session_probe__';

function isSessionStorageAvailable(): boolean {
  try {
    if (typeof window === 'undefined' || !window.sessionStorage) return false;
    const storage = window.sessionStorage;
    storage.setItem(PROBE_KEY, '1');
    const readBack = storage.getItem(PROBE_KEY);
    storage.removeItem(PROBE_KEY);
    return readBack === '1';
  } catch {
    return false;
  }
}

/**
 * Открыта ли карточка `key` («library» / «compare») по мнению текущей
 * сессии. Ключа ещё не было (первый визит) или хранилище недоступно —
 * возвращаем `defaultOpen`, который зовущий код считает сам (от количества
 * вариантов в поездке).
 */
export function loadAccordionOpen(key: string, defaultOpen: boolean): boolean {
  if (!isSessionStorageAvailable()) return defaultOpen;
  try {
    const raw = window.sessionStorage.getItem(KEY_PREFIX + key);
    if (raw === '1') return true;
    if (raw === '0') return false;
    return defaultOpen;
  } catch {
    return defaultOpen;
  }
}

/** Запомнить ручной выбор человека — до конца вкладки/сессии браузера. */
export function saveAccordionOpen(key: string, open: boolean): void {
  if (!isSessionStorageAvailable()) return;
  try {
    window.sessionStorage.setItem(KEY_PREFIX + key, open ? '1' : '0');
  } catch {
    // Квота или приватный режим — просто не запоминаем, следующий тоггл всё
    // равно попробует снова.
  }
}
